// components/ErrorContext.jsx
import { createContext, useContext, useState } from "react";

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
  const [error, setError] = useState("");

  const showError = (message) => {
    setError(message);
    setTimeout(() => setError(""), 5000); // 5秒で自動消える
  };

  return (
    <ErrorContext.Provider value={{ error, showError }}>
      {children}
      {error && <div className="error-message">{error}</div>}
    </ErrorContext.Provider>
  );
};

export const useError = () => useContext(ErrorContext);
